module.exports = __webpack_public_path__ + "img/image4.ba6ed52f.png";